import React, { Component } from "react";

function dayWithOrdinal(day) {
  const n = Number(day);
  if (n >= 11 && n <= 13) {
    return `${n}th`;
  }
  switch (n % 10) {
    case 1:
      return `${n}st`;
    case 2:
      return `${n}nd`;
    case 3:
      return `${n}rd`;
    default:
      return `${n}th`;
  }
}

/** Calendar month after today, at `dayOfMonth` (default 1). */
function getFollowingMonthDateParts(dayOfMonth = 1) {
  const now = new Date();
  const d = new Date(now.getFullYear(), now.getMonth() + 1, dayOfMonth);
  const monthName = d.toLocaleString("default", { month: "long" });
  return { monthName, dayOrdinal: dayWithOrdinal(d.getDate()) };
}

class UnderConstruction extends Component {
  render() {
    const {
      altIssue,
      fromMailPro,
      quarterlyAreaTable,
      currentArea,

      agentData,
    } = this.props;

    const following = getFollowingMonthDateParts(1);
    const { pmaScheduleID } = agentData || {};
    const mlsAreaID = currentArea?.mlsAreaID || "";
    let firstTimeAgents =
      pmaScheduleID === "NEW-AGENTS" ||
      pmaScheduleID === "NEWAGENTS" ||
      pmaScheduleID === "NEWAGENTS-TEST";
    let defaultMessage = true;
    let useSeptember = true;

    if (useSeptember) {
      return (
        <div className="under-construction">
          <p>Welcome!</p>
          <br />

          <p>
            Your {firstTimeAgents ? "first" : "next"} PMA is under development.
          </p>
          <p>
            We will send you an email letting you know when your{" "}
            {following.monthName} PMA is ready to view.
          </p>
          <br />

          <p className="green">Stay Tuned!</p>
        </div>
      );
    } else if (firstTimeAgents) {
      return (
        <div className="under-construction">
          <p>Welcome!</p>
          <br />

          <p>
            Your {firstTimeAgents ? "first" : "next"} PMA is under development.
          </p>
          <p>
            We will send you an email letting you know when your{" "}
            {following.monthName} PMA is ready to view.
          </p>
          <br />

          <p className="green">Stay Tuned!</p>
        </div>
      );
    } else if (defaultMessage) {
      return (
        <div className="under-construction">
          <p>Welcome!</p>
          <br />

          <p>
            Your {firstTimeAgents ? "first" : "next"} PMA is under development.
          </p>
          <p>
            We will send you an email on {following.monthName}{" "}
            {following.dayOrdinal} letting you know that your{" "}
            {following.monthName} version is ready to view.
          </p>
          <br />

          <p className="green">Stay Tuned!</p>
        </div>
      );
    } else if (fromMailPro == "x") {
      return (
        <div className="under-construction">
          <p>Greetings ListGen Family!</p>
          <br />

          <p>
            Your {following.monthName} Precision Market Analysis is currently
            under construction.
          </p>
          <br />

          <p>Stay tuned...It will be available to view SOON!</p>
          <br />
          <p className="green">
            We know your homeowners are going to love this PMA!
          </p>
        </div>
      );
    } else if (altIssue === "x") {
      return (
        <div className="under-construction">
          <p> Greetings Agents!</p>
          <br />

          <p>
            Your {following.monthName} Precision Market Analysis is currently
            under construction.
          </p>
          <br />

          <p>Stay tuned...It will be available to view SOON!</p>
          <br />
          <p className="green">
            We know your homeowners are going to love this PMA!
          </p>
          <div className="compass-margin-top-construction">
            <p> In the meantime, MailPro is is LIVE!</p>
            <p>
              Feel free to PERSONALIZE your Homeowners' names and click through
              your Happy Anniversary! notes, TAG Homeowners' you want to keep
              track of, and write any PERSONAL NOTE to Homeowners you know and
              want to send a special 'Hello' to...
            </p>
            <p>
              {" "}
              Of course, all your updates are automatically saved.&#128521;
            </p>
          </div>
        </div>
      );
    } else {
      return (
        <div className="under-construction">
          <p>Greetings ListGen Family!</p>
          <br />

          <p>
            Your New <span className="blue">PMA</span> is under
            construction{" "}
          </p>
          <p>
            and will be available soon. We will send out an email once
            everything is available. Stay tuned!
          </p>
          <br />
          {/*<p>We will have your other PMA's ready to look at later today</p>*/}
          {/*<p>
            Please feel free to create your own <strong>Global Note</strong>{" "}
            and/or any <strong>Personal Notes in MailPro</strong>
          </p>
          <br />
          <p>All your inputs are automatically saved!</p>
          <br />*/}

          {/*<p style={{ color: "red", fontSize: "20px" }}>
            <strong>
              This PMA is scheduled to be completed for you to review on Saturday
              February 20th.
            </strong>
          </p>
          <br />*/}
          {/*<p>
            As usual, we will Express Mail a hard copy of your PMAs on Wednesday
            January 13th.{" "}
          </p>
          <br />*/}

          {/*<p className="blue">The scheduled mail date is Monday January 18th. </p>
          <br />*/}
          <p className="green">
            We know your homeowners are going to love this PMA!
          </p>
        </div>
      );
    }
  }
}

export default UnderConstruction;
